import { ParsedUrlQuery } from "querystring";
import {
  BroadcastCommunicationType,
  BroadcastReportingInputBase,
} from "~graphql/sdk";
import * as Sentry from "@sentry/nextjs";

export type BroadcastReportingTrackingRaw = {
  communicationType: BroadcastCommunicationType;
  rawData: string;
};

export type BroadcastReportingTracking = BroadcastReportingInputBase &
  BroadcastReportingTrackingRaw;

export const broadcastParamsFromReportingString = (
  communicationType: BroadcastCommunicationType,
  reportingString: string
): BroadcastReportingTracking => {
  try {
    return {
      ...(JSON.parse(reportingString) as BroadcastReportingInputBase),
      communicationType,
      rawData: reportingString,
    };
  } catch (e) {
    Sentry.captureException(
      new Error("Error de-serialising broadcast reporting params"),
      {
        tags: {
          action: "broadcastParamsFromReportingId",
        },
        extra: {
          args: reportingString,
          error: e,
        },
      }
    );
  }
};

export const getBroadcastParamsFromQuery = (
  query: ParsedUrlQuery
): BroadcastReportingTracking | null => {
  const broadcastType: BroadcastCommunicationType | null = query?.[
    "campaign-id"
  ]
    ? BroadcastCommunicationType.Email
    : query?.["sms-campaign-id"]
      ? BroadcastCommunicationType.Sms
      : null;

  const reportingString = (query?.["campaign-id"] ??
    query?.["sms-campaign-id"] ??
    "") as string;

  return reportingString
    ? broadcastParamsFromReportingString(broadcastType, reportingString)
    : null;
};
